import React, { KeyboardEventHandler, useMemo } from 'react';
import { FuelTextField } from '@frete.com/fuel-react';
import { InputProps } from './types';
import { useCellphoneInput } from '@/hooks';

export const CellphoneInput: React.FC<InputProps> = ({
  value = '',
  onUpdate,
  label,
  placeholder,
  maxLength,
  error,
  name,
  onEnter,
  onFocus,
  onBlur,
  autoFocus,
  required = false,
  disabled = false,
  mask = [],
  unmaskedValue = false,
  monetary = false,
  type,
  anonymizeOnBlur,
  applyMaskCheckOwner,
}) => {
  const { inputRef, getDisplayValue, handleInputChange, handleFocus, handleBlur, anonymizationState } =
    useCellphoneInput({
      value,
      onUpdate,
      mask,
      monetary,
      unmaskedValue,
      anonymizeOnBlur,
      applyMaskCheckOwner,
      name,
    });

  const onInput = (event: CustomEvent) => {
    handleInputChange(event.detail.value);
  };

  const reference = (element: HTMLFuelTextFieldElement) => {
    inputRef.current = element;
  };

  const onKeyUp: KeyboardEventHandler<any> = (event) => {
    if (event.key === 'Enter' && onEnter) onEnter();
  };

  const currentError = useMemo(() => (!disabled && typeof error === 'string' ? error : ''), [error, disabled]);

  const currentState = useMemo(() => (currentError ? 'error' : 'default'), [type, currentError]);

  return (
    <FuelTextField
      controlled
      disabled={disabled}
      hint={currentError}
      label={label}
      maxlength={maxLength}
      name={name}
      onFuel-input={onInput}
      onFuel-focus={(e) => {
        handleFocus();
        if (!applyMaskCheckOwner && !anonymizationState.wasEdited) {
          onFocus?.(e);
        }
      }}
      onFuel-blur={(e) => {
        handleBlur();
        if (!anonymizationState.wasEdited && !applyMaskCheckOwner) {
          onBlur?.(e);
        }
      }}
      placeholder={placeholder}
      setAutofocus={autoFocus}
      required={required}
      state={currentState}
      value={getDisplayValue as string}
      onKeyUp={onKeyUp}
      ref={reference}
    />
  );
};
